import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import TutorialPopup from "../../../help/TutorialPopup";
import useInput from "../../../hooks/useIndicatorInput";
import * as HelpContent from "../../../../utils/HelpContent";

const VolumeSettings = (props) => {
  const { indicator, updateIndicator, baseCoin,t } = props;

  const [avgVol, bindAvgVol, setAvgVol] = useInput(indicator.value2, 0);
  const [interval, bindInterval, setInterval] = useInput(indicator.period_num, 0);
  

  useEffect(() => {
    setAvgVol(indicator.value2);
    setInterval(indicator.period_num);
  }, [indicator]);

  const  restrictAlphabets = (e)=>{
    var x = e.which || e.keycode;
    if(!(x>=46 && x<=57))
      e.preventDefault()
    
  }

  useEffect(() => {
    let val  = interval>10?10:((interval<2 && interval!="") ?2:interval) 
    updateIndicator({
        ...indicator,
        period_num: val,
        value2: avgVol,
    });
   
  }, [avgVol, interval]);
  return (
    <div>
    <Form.Group>
    Minimum Average Volume <Form.Control type="number"  className="grid-input" {...bindAvgVol} /> {baseCoin} <br></br>for  previous 
    <Form.Control type="number"  className="grid-input" {...bindInterval} max={10} min={2} /> intervals.<TutorialPopup content={t("volumeIndicator")} />
    </Form.Group>
      
    </div>
  );
};

export default VolumeSettings;
